import React from 'react'
import {DynamicField} from '../../../../accountManagement/features/AccountInfo/components/DynamicField'
import {ValidateInputField} from './fields/ValidateInputField'
import {YesNoField} from './fields/YesNoField'

// Local field router for ProductPlanSelector.
// Handles plan-specific field types first; standard types (text, select, toggle,
// async-search) fall through to AccountInfo's DynamicField unchanged.
//
// To add a new plan-specific type:
//   1. Create the field component in this folder
//   2. Add a case here
//   3. Add the field definition to planFieldsConfig.js

export function PlanDynamicField({field, onValidated, ...props}) {
  switch (field.type) {
    case 'validate-input':
      return (
        <ValidateInputField
          field={field}
          onValidated={onValidated}
          {...props}
        />
      )
    case 'yes-no':
      return <YesNoField field={field} {...props} />
    default:
      // fall back to AccountInfo's DynamicField for standard field types
      return <DynamicField field={field} {...props} />
  }
}
